<template>
  <div class="container">
    <pi-tabs
      v-if="tabsList.length > 1"
      :list="tabsList"
      :active="tabs"
      @change="tabClick"
    ></pi-tabs>
    <template v-for="(item, index) in tabsList">
      <div class="container-flex" v-if="item.value == tabs" :key="index">
        <pi-statistics-centent :type="item.value"></pi-statistics-centent>
      </div>
    </template>
  </div>
</template>
<script>
import statisticsData from "./my-statistics-data";
import statisticsCentent from './components/statistics-centent/statistics-centent.vue'
import piTabs from "@/components/pi-tabs/pi-tabs";
export default {
  name: "my-statistics",
  components: {
    [statisticsCentent.name]: statisticsCentent,
    [piTabs.name]: piTabs,
  },
  data() {
    return {
      tabsList: [],
      tabs: "",
      tabs2: false,
      tabs3: false,
      cententKey: statisticsData.cententKey,
    };
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      let query = this.$route.query;
      let type = query.type || "member";
      this.tabsList = statisticsData.cententTabsList[type];
      this.tabs = this.tabsList[0].value;
      this.pageType = type;
    },
    tabClick(item) {
      this.tabs = item.value;
    },
  },
};
</script>

<style lang="less" scoped>
.order-item {
  margin-top: 0.20rem;
  border-bottom: 0.01rem solid #EEEEEE;
  padding: 0.20rem;
  font-size: 0.32rem;
  line-height: 0.48rem;
  display: flex;
}

.order-no {
  flex: 1;
  font-size: 0.40rem;
}

.order-status {
  color: #14CC80;
}

.order-status.yes {
  color: #FFA244;
}

.order-icon {
  display: flex;
  justify-items: center;
  align-items: center;
}

.order-icon img {
  width: 0.40rem;
  height: 0.40rem;
}
</style>
